module.exports = __webpack_public_path__ + "img/purchase3.05dcaf8d.png";